import { UilParagraph } from '@iconscout/react-unicons';
import Unicon from 'components/base/Unicon';
import { ReactNode, useState } from 'react';
import { Props } from './mobileNav.type';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { LandingRole } from 'pages/landing/main.type';
import Button from 'components/base/Button';

const MobileNav = ({ navsList, role }: Props) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  const isHaveNavs = navsList.length > 0;

  const signUpButtonMapping: Record<LandingRole, ReactNode | null> = {
    default: (
      <Button
        variant="subtle-secondary"
        className={`w-100 ${isHaveNavs ? 'mt-3' : ''}`}
        as={Link}
        to="/register/institution/basic"
      >
        Sign Up
      </Button>
    ),
    student: null,
    recruiter: (
      <Button
        variant="subtle-secondary"
        className={`w-100 ${isHaveNavs ? 'mt-3' : ''}`}
        as={Link}
        to="/register/recruiter/basic"
      >
        Sign Up
      </Button>
    ),
    college: (
      <Button
        variant="subtle-secondary"
        className={`w-100 ${isHaveNavs ? 'mt-3' : ''}`}
        as={Link}
        to="/register/institution/basic"
      >
        Sign Up
      </Button>
    )
  };

  const handleLogin = () => {
    window.location.href = '/sign-in';
  };

  const handleNavigate = (pathName: string) => {
    navigate(pathName);
  };

  return (
    <div>
      <div className="ms-3 d-block d-lg-none">
        <Unicon
          icon={UilParagraph}
          className="cursor-pointer"
          onClick={() => setShowMenu(prev => !prev)}
        />
      </div>
      <div className={`mobileNav_navs-${showMenu ? 'open' : 'close'} z-50`}>
        <div>
          <div className="py-5 d-flex justify-content-end">
            <FontAwesomeIcon
              icon={faClose}
              size={'xl'}
              color={'#8a94ad'}
              className="cursor-pointer"
              onClick={() => setShowMenu(prev => !prev)}
            />
          </div>
          {navsList.map((nav, index) =>
            nav.isDropdown ? (
              <Dropdown className="d-inline m-0" key={index}>
                <Dropdown.Toggle
                  id="dropdown-autoclose-true"
                  className="bg-transparent text-body-highlight fs-8 fw-normal px-0 customToggleStyle pb-3"
                >
                  {nav.label}
                </Dropdown.Toggle>
                {Array.isArray(nav.childNavs) && (
                  <Dropdown.Menu>
                    {nav.childNavs.map((list, index) => (
                      <Dropdown.Item
                        as={Link}
                        to={list.path}
                        key={`${index}-childNav`}
                      >
                        {list.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                )}
              </Dropdown>
            ) : (
              <div
                key={`nav-${index}`}
                onClick={() => handleNavigate(nav.path)}
              >
                <p>{nav.label}</p>
              </div>
            )
          )}
          <div>
            {signUpButtonMapping[role]}
            <button
              className="customPrimaryButton w-100 mt-3"
              onClick={handleLogin}
            >
              Log In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
